import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import connect from "react-redux/es/connect/connect";
import FusePageCarded from "../../../@fuse/components/FusePageLayouts/FusePageCarded";

import {API} from "../../../config";
import { companySelector } from '../../../store/reducers/company.reducer';
import Custodian from './components/custodian';
import Internal from './components/internal';
import _ from 'lodash';
import {Button, Input, Typography} from "@material-ui/core";

import { PDFExport } from '@progress/kendo-react-pdf';
import PageTemplate from '../../ReportTemplates/SettlementReport';
import Util from "../../../yeffect/utils";


const moment = require('moment');

const companies = API.service('company');
const brokers = API.service('authorized-brokers');

const styles = theme => ({
  layoutRoot: {
    backgroundColor: '#23272f',
    display: 'flex',
    flex: 1,
    height: '100vh',
    overflow: 'hidden'
  },
  container: {
    flex: '1 0 auto',
  },
  content: {
    minHeight:'1000px',
    padding: 10,
    width:'100%'
  },
  dataContainer: {
    height: 'calc(100% - 148px)',
    marginTop: 20,
  },
  tabRoot: {
    minWidth: 100,
  },
  tabcontent: {
    borderTop: "1px solid #1890ff"
  },
  textBox: {
    border: '1px solid white',
    borderRadius: 12,
    fontSize: 12,
    height: 40,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '45%',
    color: 'white',
    margin: theme.spacing.unit,
  },
  row: {
    height: "auto",

    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default
    }
  },
  cell: {
    padding: '4px 8px 4px 8px'
  },
  flexBox: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#23272f',

    '&.center': {
      alignItems: 'center',
    }
  },
});

class Settlement extends Component {
  state = {
    loading:true,
    companies:false,
    brokers:false,
    completed_trades:false,
    certificates:false,
    opening:false,
    startDate:moment().subtract('1','Month').format('YYYY-MM-DD'),
    endDate:moment().format('YYYY-MM-DD'),
    reportContent:'',
  };

  loadData = () =>{
    const app = this;

    companies.find({query:{_status:0,$limit:1000}}).then((c)=>{
      app.setState({
        companies:c.data
      })
    }); //companies.find

    brokers.find({query:{$limit:1000}}).then((b)=>{
      app.setState({
        brokers:b.data
      })
    }); //companies.find
  };

  genPDF = () => {
    this.report.save();
  };

  componentDidMount() {

  }

  updateDate = (event) => {
    this.setState(_.set({ ...this.state, error: '' }, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
    this.setState({companies:false,brokers:false});
  }

  render() {
    const { classes } = this.props
    let html_content = "";
    if(this.state.companies && this.state.brokers){
      html_content = (
        <div className={classes.content}>
          {(this.state.companies) &&
          <React.Fragment>
            <Typography style={{marginTop:'40px'}} variant={'headline'}>Custodian Depository Holding Report</Typography>
    <br />
    <br />
            <table cellPadding={0} cellSpacing={0}>
              <tr>
                <td style={{paddingRight:'20px'}}><span style={{fontWeight:'bold'}}>Report Period</span></td>
                <td><b>Date Start:</b></td>
                <td>{this.state.startDate}</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td><b>Date End:</b></td>
                <td>{this.state.endDate}</td>
              </tr>
            </table>
    <br />
    <br />
            <table style={{width:'100%'}} cellPadding={0} cellSpacing={0}>
              <tr>
                <td style={{paddingRight:'20px'}}><span style={{fontWeight:'bold'}}>Custodians</span></td>
                <td><b>Name</b></td>
                <td><b>Address</b></td>
                <td><b>Contact</b></td>
                <td><b>Phone</b></td>
                <td><b>Email</b></td>
              </tr>
              <tr style={{verticalAlign:'top'}}>
                <td>&nbsp;</td>
                <td style={{paddingRight:'20px'}}>Vidanova Bank N.V.</td>
                <td style={{paddingRight:'20px'}}>Schottegatweg Oost 44<br />
                  P.O. Box 707<br />
                  Willemstad, Curaçao</td>
                <td style={{paddingRight:'20px'}}>-- N/A --</td>
                <td style={{paddingRight:'20px'}}>(599-9) 732-2900</td>
                <td style={{paddingRight:'20px'}}>-- N/A --</td>
              </tr>
            </table>

            <Typography style={{marginTop:'40px'}} variant={'headline'}>Deposits with Custodians</Typography>
            <Typography style={{marginTop:'15px'}} variant={'title'}>Vidanova Bank N.V.</Typography>
            <table style={{width:'100%'}} cellPadding={0} cellSpacing={0}>
              <colgroup>
                <col width={"2%"}/>
                <col />
                <col width={"25%"}/>
                <col />
                <col />
                <col />
                <col />
                <col width={"8%"}/>
                <col />
                <col width={"8%"}/>
                <col />
                <col />
                <col width={"8%"}/>
              </colgroup>
              <tr>
                <td style={{paddingRight:'20px'}}>&nbsp;</td>
                <td><b>Instruments Deposited</b></td>
                <td colSpan={10}>&nbsp;</td>
              </tr>
              <tr>
                <td style={{paddingRight:'20px'}}>&nbsp;</td>
                <td colSpan={11}>&nbsp;</td>
              </tr>
              <tr>
                <td style={{backgroundColor:'white'}}>&nbsp;</td>
                <td style={{color:'white',backgroundColor:'#6e6e6e',paddingRight:'10px',paddingLeft:'10px'}}><b>Type</b></td>
                <td style={{color:'white',backgroundColor:'#6e6e6e',paddingRight:'10px',paddingLeft:'10px',width:'20%'}}><b>Name</b></td>
                <td style={{color:'white',backgroundColor:'#6e6e6e',paddingRight:'10px',paddingLeft:'10px'}}><b>ISIN</b></td>
                <td style={{color:'white',backgroundColor:'#6e6e6e',paddingRight:'10px',paddingLeft:'10px'}}><b>FISN</b></td>
                <td style={{color:'white',backgroundColor:'#6e6e6e',paddingRight:'10px',paddingLeft:'10px'}}><b>CFI</b></td>
                <td style={{color:'white',backgroundColor:'#6e6e6e',paddingRight:'10px',paddingLeft:'10px'}}><b>Class</b></td>
                <td style={{color:'white',backgroundColor:'#6e6e6e',paddingRight:'10px',paddingLeft:'10px'}}><b>Total Units</b></td>
                <td style={{color:'white',backgroundColor:'#6e6e6e',paddingRight:'10px',paddingLeft:'10px'}}><b>Trading</b></td>
                <td style={{color:'white',backgroundColor:'#6e6e6e',paddingRight:'10px',paddingLeft:'10px'}}><b>Symbol</b></td>
                <td style={{color:'white',backgroundColor:'#6e6e6e',paddingRight:'10px',paddingLeft:'10px'}}><b>Address</b></td>
                <td style={{color:'white',backgroundColor:'#6e6e6e',paddingRight:'10px',paddingLeft:'10px'}}><b>Email</b></td>
                <td style={{color:'white',backgroundColor:'#6e6e6e'}}><b>Date Deposited</b></td>
              </tr>
            {this.state.companies.map((v, i) => {
                return (
                      <tr style={{verticalAlign:'top'}}>
                        <td>&nbsp;</td>
                        <td style={{paddingRight:'10px',paddingLeft:'10px'}}>&nbsp;</td>
                        <td style={{paddingRight:'10px',paddingLeft:'10px'}}>{v._company_name}</td>
                        <td style={{paddingRight:'10px',paddingLeft:'10px'}}>&nbsp;</td>
                        <td style={{paddingRight:'10px',paddingLeft:'10px'}}>&nbsp;</td>
                        <td style={{paddingRight:'10px',paddingLeft:'10px'}}>&nbsp;</td>
                        <td style={{paddingRight:'10px',paddingLeft:'10px'}}>&nbsp;</td>
                        <td style={{paddingRight:'10px',paddingLeft:'10px',textAlign:'right'}}>{Util.addThousandCommas(v._shares_issued)}</td>
                        <td style={{paddingRight:'10px',paddingLeft:'10px'}}>{(v._status === 0) ? 'Yes' : 'No'}</td>
                        <td style={{paddingRight:'10px',paddingLeft:'10px'}}>{v._company_symbol}</td>
                        <td style={{paddingRight:'10px',paddingLeft:'10px'}}>&nbsp;</td>
                        <td style={{paddingRight:'10px',paddingLeft:'10px'}}>&nbsp;</td>
                      </tr>
                )
              }
            )}
            </table>

            <span className={'page-break'} style={{marginTop:'30px', marginLeft:'30px'}}><b>Instruments</b></span>
            {this.state.companies.map((v, i) => {
              return (
                <div key={i} style={{marginTop:'45px'}} className={'custTable'}>
                  <div style={{marginLeft:'60px'}}><b>{v._company_name}</b></div>
                  <div style={{marginLeft:'60px'}}>
                  <Custodian
                    company={v._company_account}
                    name={v._company_name}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                  />
                  </div>
                </div>
              )
            })}
          </React.Fragment>
          }



          {(this.state.brokers) &&
          <React.Fragment>
            <Typography className={'page-break'} style={{marginTop:'40px'}} variant={'title'}>USD Broker Settlement Statement: {this.state.startDate} - {this.state.endDate}</Typography>
            {this.state.brokers.map((v, i) => {
              return (
                <div key={i} style={{marginTop:'45px'}}>
                  <Typography variant={'title'}>{v._name}</Typography>
                  <Internal
                    broker={v}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                  />
                </div>
              )
            })}
          </React.Fragment>
          }

        </div>
      );
    }

    return (

      <FusePageCarded
        classes={{
          root: classes.layoutRoot
        }}
        header={
          <div />
        }
        content={
          <div className={classes.content}>
            Start Date:<br />
            <Input
              type={"date"}
              name={'startDate'}
              value={this.state.startDate}
              onChange={this.updateDate}
              style={{
                color: 'black',
                background: 'white',
                borderRadius:'3px',
                padding:'5px'
              }}
            /><br /><br/>
            End Date:<br />
            <Input
              type={"date"}
              name={'endDate'}
              value={this.state.endDate}
              onChange={this.updateDate}
              style={{
                color: 'black',
                background: 'white',
                borderRadius:'3px',
                padding:'5px'
              }}
            /><br /><br/>
            <Button variant="raised"
                    color="secondary"
                    onClick={this.loadData}>
              Generate
            </Button>
            {(this.state.companies) && (this.state.brokers) &&
              <React.Fragment>
                &nbsp;&nbsp;<Button variant="raised"
                        color="secondary" onClick= {this.genPDF}>Save PDF</Button>
                <PDFExport paperSize={'A4'}
                           landscape={true}
                           forcePageBreak=".page-break"
                           keepTogether=".internal, .custTable"
                           pageTemplate={PageTemplate}
                           fileName="Settlement.pdf"
                           title="Settlement Report"
                           subject=""
                           scale={0.5}
                           margin={{ top: 40, left: 20, right: 20, bottom: 20 }}
                           keywords=""
                           ref={(r) => this.report = r}>
                  {html_content}
                </PDFExport>
              </React.Fragment>
            }
          </div>
        }
      />
    )
  }
}

const mapStateToProps = state => ({
  selectedCompany: companySelector(state),
});

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps)(withRouter(Settlement)));



// WEBPACK FOOTER //
// ./src/main/content/settlement/Settlement.js